import { Component, OnDestroy, OnInit } from "@angular/core";

import { DialogComponent } from "../../shared/components/dialog/dialog.component";
import { DialogRef } from "../../shared/components/dialog/dialog.ref";

@Component({
  selector: 'app-chart-info-dialog',
  templateUrl: './chart-info-dialog.component.html',
  styleUrls: ['./chart-info-dialog.component.scss']
})
export class ChartInfoDialogComponent extends DialogComponent<undefined, undefined>() implements OnInit, OnDestroy {

  constructor(
    public readonly ref: DialogRef<boolean>
  ) {
    super(ref);
  }

  static override isPopIn = true;
  
  chartAxesDescriptions = [
    {
      title: 'Quotidien',
      description: 'L\'épanouissement lié à vos activités et interactions de la vie de tous les jours.'
    },
    {
      title: 'Sens',
      description: 'Votre sentiment d\'utilité envers les autres, le sens que vous accordez à votre vie, le sentiment d\'être à votre place.'
    },
    {
      title: 'Confiance en soi',
      description: 'L\'estime que vous vous portez et la confiance en vos décisions et actions.'
    },
    {
      title: 'Humeur',
      description: 'Votre énergie mentale et état d\'esprit global.'
    },
    {
      title: 'Interactions',
      description: 'Votre relation aux autres et ce que vous en tirez.'
    },
    {
      title: 'Reconnaissance pro.',
      description: 'Le sentiment que vous êtes compétent et reconnu à votre poste.'
    },
    {
      title: 'Motivation au travail',
      description: 'L\'intérêt que vous portez à votre métier, votre envie de fournir des efforts.'
    },
    {
      title: 'Concentration',
      description: 'Votre capacité d\'attention et de focus cognitif.'
    },
    {
      title: 'Santé',
      description: 'Votre énergie physique et votre relation avec votre corps.'
    },
    {
      title: 'Société',
      description: 'L\'impact des événements sociétaux sur votre mental, votre capacité à vous protéger.'
    }
  ];

  ngOnInit() {
    super.onInit();
  }
  
  ngOnDestroy() {
    super.onDestroy();
  }
  
  override close() {
    super.close();
  }
}